
import {logger} from '../utils/logger.js';


const getUserMediaStat = {

    NotGet:1,
    Getting:2,
    GetSucc:3

}


class VideoWebRtcRender {

    player;

    width;
    height;
    tag = 'VideoWebRtcRender'


    constructor(player, video) {

        this.player = player;
        this.video = video;

        this.width = video.width;
        this.height = video.height;


        this.pc = new RTCPeerConnection(null);
        
        this.stream = new MediaStream();
        this.pc.ontrack = (event) => {
            this.stream.addTrack(event.track);
        };

        this.video.srcObject = this.stream;

        this.getState = getUserMediaStat.NotGet
 
    }


    async createOfferSDP() {
        // this.pc.addTransceiver("audio", {direction: "recvonly"});
        this.pc.addTransceiver("audio", {direction: "sendrecv"});
        this.pc.addTransceiver("video", {direction: "recvonly"});
    
        const offer = await this.pc.createOffer();
        await this.pc.setLocalDescription(offer);
        this.pc.onicecandidate = function(event) {
            if (event.candidate) {
                console.log("收集到候选者信息:", event.candidate);
            }
        };
    
        // 等待 2 秒后返回 SDP
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(offer.sdp);
            }, 2000);
        });
    } 
  
   async setAnswerSDP(answerSDP) {

        await this.pc.setRemoteDescription(
            new RTCSessionDescription({type: 'answer', sdp: answerSDP})
        )

        this.startPlayVideo()
    }



    startPlayVideo() {

        this.video.play().then(()=>{

            logger.info(this.tag, 'video label start play');

        }).catch((e) =>{

            logger.info(this.tag, `video label start play err ${e}`);

        })
    }

    mute() {

        this.video.muted = true
    }


    unMute() {

        this.video.muted = false
    }
   
    setVolume(num){
        this.video.volume = num
    }

    startTalk() {

        if (this.getState == getUserMediaStat.NotGet) {

            this.getState = getUserMediaStat.Getting

            navigator.mediaDevices.getUserMedia({audio: true}).then((stream) => {

                this.pc.addStream(stream);
                this.microphoneStream = stream
                this.getState = getUserMediaStat.GetSucc
                
                logger.info(this.tag, `start talk, get microphone success and add microphone stream to webrtc`);
            })
            .catch((error) => {

                logger.error(this.tag, `start talk, get microphone fail ${error}`);
                this.getState = getUserMediaStat.NotGet
            });

        } else if (this.getState == getUserMediaStat.Getting) {

            logger.warn(this.tag, `start talk, is getting microphone, nothing to do`);

        } else if (this.getState == getUserMediaStat.GetSucc) {

            this.microphoneStream.getTracks()[0].enabled = true;
            logger.info(this.tag, `start talk, enable microphone`);
        } else {

            logger.error(this.tag, `start talk, but get microphone state ${this.getState} not predefined, some err happen`);
        }

    }


    stopTalk() {

        if (this.getState == getUserMediaStat.NotGet) {

            logger.warn(this.tag, `stop talk, microphone not get, nothing to do`);

        } else if (this.getState == getUserMediaStat.Getting) {

            logger.warn(this.tag, `stop talk, microphone is getting, nothing to do`);

        } else if (this.getState == getUserMediaStat.GetSucc) {

            this.microphoneStream.getTracks()[0].enabled = false;
            logger.info(this.tag, `stop talk, disable microphone`);
        } else {
            logger.error(this.tag, `stop talk, but get microphone state ${this.getState} not predefined, some err happen`);
        }

    }
  
    destroy() {

        if (this.video) {
            this.video.pause();
            this.video.currentTime = 0;
            if (this.video.srcObject) {
                this.video.srcObject = null;
                this.video.removeAttribute('srcObject');
            }
            try {
                this.video.load();
            } catch (e) {
                // ignore
            }
        }

        if (this.pc) {
            this.pc.close()
        }

        logger.info(this.tag, 'VideoWebRtcRender destroy');

    }



}


export default VideoWebRtcRender;
